import { useEffect } from 'react'
import { countStructures } from '../../utils/regionStats'

// Merge the logged-in player's owned-country stats into feature properties (flat
// keys so MapLibre expressions can read them). Only own regions get a stat_has
// marker — every other region stays unmarked and renders neutral. Applied to
// both projection datasets, then pushed to the active source.
export function useOwnedStats(map, { regionStats, structFilter, regionsData, regionsMercatorData, regionsGlobeData }) {
  useEffect(() => {
    if (!map.current || !regionsData || !map.current.getSource('regions')) return
    if (!regionStats || Object.keys(regionStats).length === 0) return

    const applyTo = (dataset) => {
      if (!dataset) return
      dataset.features.forEach((feature) => {
        const id = feature.properties.region_id
        const s = regionStats[id] ?? regionStats[String(id)]
        if (!s) return
        const p = feature.properties
        p.stat_has = true
        p.stat_housing_capacity = s.housing?.capacity ?? 0
        p.stat_housing_coverage = s.housing?.coverage_pct ?? 0
        p.stat_comfort = s.housing?.average_comfort ?? 0
        p.stat_elec_production = s.electricity?.production_mwh ?? 0
        p.stat_elec_consumption = s.electricity?.consumption_mwh ?? 0
        p.stat_elec_meeting = s.electricity?.meeting_pct ?? 0
        Object.entries(s.structures || {}).forEach(([t, n]) => { p[`stat_struct_${t}`] = n })
        Object.entries(s.infrastructure || {}).forEach(([t, n]) => { p[`stat_infra_${t}`] = n })
        // Structures heatmap value for the current type/spec/level filter.
        p.stat_struct_sel = countStructures(s.structures_detail, structFilter)
      })
    }

    applyTo(regionsMercatorData)
    applyTo(regionsGlobeData)

    const source = map.current.getSource('regions')
    if (source) {
      source.setData({ type: regionsData.type, features: regionsData.features })
    }
  }, [map, regionStats, regionsData, regionsMercatorData, regionsGlobeData, structFilter])
}
